import { Component, Input, signal } from '@angular/core';
import { ChevronDown, ChevronUp, LucideAngularModule } from 'lucide-angular';

@Component({
  selector: 'app-accordion',
  standalone: true,
  imports: [LucideAngularModule],
  templateUrl: './accordion.component.html',
})
export class AccordionComponent {
  @Input() title: string = '';
  @Input() isInitiallyOpen: boolean = false;

  readonly chevronDown = ChevronDown;
  readonly chevronUp = ChevronUp;

  isOpen = signal(this.isInitiallyOpen);

  ngOnInit() {
    this.isOpen.set(this.isInitiallyOpen);
  }

  toggle() {
    this.isOpen.update((current) => !current);
  }
}
